export class Login {
  public username;
  public password;
  public plainPassword?: string;
  public rememberMe = true;
  public recaptchaToken: string;
  public auth_code: string;
}
